import React from 'react';

import Container from '../common/Container.jsx';
import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region PROMO CODES

function PromoCodes(props) {
    const data = props.data || {};
    const hasPromoCodes = data.PromoCodes && data.PromoCodes.length > 0;
    if (!props.builder && !hasPromoCodes) {
        return null;
    }
    // const config = props.config || {};
    // let blockProps = {};
    // if (config.config && config.config.Block) {
    //     blockProps = config.config.Block;
    // }
    const rowStyle = {};
    // if (blockProps.rowSpacing && !Utilities.isNullOrWhitespace(blockProps.rowSpacing.value)) {
    //     rowStyle.paddingTop = `${blockProps.rowSpacing.value}${blockProps.rowSpacing.unit}`;
    // }
    const localization = data.Gallery && data.Gallery.Localization;
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            {
                data.PromoCodes &&
                data.PromoCodes.map((d, i) =>
                    <PromoCodeLine
                        key={i}
                        {...props}
                        container={false}
                        data={d}
                        localization={localization}
                        rowStyle={i > 0 ? rowStyle : undefined} />
                )
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            !hasPromoCodes &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    );
}
function _PromoCodeLine(props) { return <LabelValue {...props} value={props.content} /> }
const PromoCodeLine = withLabelTokenParsing(_PromoCodeLine, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.PromoDiscount:
            if (data.DiscountType != 1 && data.ExchangeRate && data.ExchangeRate.Value != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Value, options);
            }
            break;
        case Token.Total.PromoCode.Code:
            if (data.Code != null) {
                replaceString = data.Code;
            }
            break;
        case Token.Total.PromoCode.Description:
            if (data.Description != null) {
                replaceString = data.Description;
            }
            break;
        case Token.Total.PromoCode.Discount:
            if (data.Discount != undefined) {
                replaceString = Utilities.Format.getDiscountString(data, props.index, props.localization, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const discountToken = Token.getCurrencyTokenConfig('Discount', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Total.PromoCode.Discount);
    discountToken.options.push({ defaultValue: Utilities.Format.Percent.getDefaultFormatString(), display: 'Percent Format', name: 'percentFormat', note: 'Keywords: [Value]', type: 'percentFormat' })
    return [
        { display: 'Code', token: Token.Total.PromoCode.Code },
        { display: 'Description', token: Token.Total.PromoCode.Description },
        discountToken,
        Token.getWrappedTokenConfig('Discount (Display Currency)', Token.DisplayCurrency.PromoDiscount)
    ]
};
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block('3'),
        description: () => LabelValueTypeConfig.panel.description(Utilities.wrapTextForEditor({ text: `{${Token.Total.PromoCode.Description}}`, token: Token.Total.PromoCode.Description })),
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: `{${Token.Total.PromoCode.Code}}`, token: Token.Total.PromoCode.Code })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.PromoCode.Discount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","percentFormat":"${Utilities.Format.Percent.getDefaultFormatString()}")}`, token: Token.Total.PromoCode.Discount }))
    }
};

// #endregion PROMO CODES

export {
    PromoCodes as Component,
    Tokens,
    TypeConfig
}